import DeviceStatuses from './DeviceStatuses';

export default DeviceStatuses;